import { Resource } from '@core';
import { featureFlags } from '@core/consts';
import { head, isNil } from 'lodash';

import { Route } from './utils';

const { facilitySubcategoryEnabled, creditCardsSubcategoryEnabled, loansSubcategoryEnabled } = featureFlags;

const compressSubRoutes = (val: Record<string, Route | undefined | null | false>): Record<string, Route> => {
  const res: Record<string, Route> = {};
  for (const key in val) {
    const item = val[key];
    if (item) res[key] = item;
  }
  return res;
};

export const merchantCategoryRoutes = {
  careSupport: {
    label: 'All Care Support',
    url: '/care-support',
    sub: {
      careConsultants: { label: 'Care Consultants', url: '/care-support/care-consultants', index: 0 },
      careTech: { label: 'Care Tech / Medical Products', url: '/care-support/care-tech', index: 1 },
      getStuffDone: { label: 'Get Stuff Done', url: '/care-support/get-stuff-done', index: 2 },
      gifts: { label: 'Gifts', url: '/care-support/gifts', index: 3 },
      paidHelpers: { label: 'Paid Helpers', url: '/care-support/paid-helpers', index: 4 },
      petsToo: { label: 'Pets Too', url: '/care-support/pets-too', index: 5 },
    },
  },
  health: {
    label: 'All Health',
    url: '/health',
    sub: {
      mental: { label: 'Mental Health', url: '/health/mental-health', index: 0 },
      diet: { label: 'Nutrition / Diet', url: '/health/nutrition', index: 1 },
      physical: { label: 'Physical Health', url: '/health/physical', index: 2 },
    },
  },
  housing: {
    label: 'All Housing',
    url: '/housing',
    sub: compressSubRoutes({
      facility: facilitySubcategoryEnabled ? { label: 'A Facility', url: '/housing/facility', index: 0 } : undefined,
      home: { label: 'At Home', url: '/housing/at-home', index: 0 },
    }),
  },
  legal: {
    label: 'All Legal',
    url: '/legal',
    sub: {
      planning: { label: 'Planning', url: '/legal/planning', index: 0 },
      wishes: { label: 'Wishes', url: '/legal/wishes', index: 1 },
    },
  },
  finance: {
    label: 'All Finance',
    url: '/finance',
    sub: compressSubRoutes({
      assets: {
        label: 'Assets',
        url: '/finance/assets',
        index: 0,
      },
      creditCards: creditCardsSubcategoryEnabled
        ? {
            label: 'Credit Cards',
            url: '/finance/credit-cards',
            index: 1,
          }
        : undefined,
      fraudProtection: {
        label: 'Fraud Protection',
        url: '/finance/fraud-protection',
        index: 2,
      },
      governmentBenefits: {
        label: 'Government Benefits',
        url: '/finance/government-benefits',
        index: 3,
      },
      insurance: {
        label: 'Insurance',
        url: '/finance/insurance',
        index: 4,
      },
      loans: loansSubcategoryEnabled
        ? {
            label: 'Loans',
            url: '/finance/loans',
            index: 5,
          }
        : undefined,
      services: {
        label: 'Services',
        url: '/finance/services',
        index: 6,
      },
    }),
  },
};

export const getSeeMoreRelatedMerchantsLink = (merchants: Resource[]) => {
  if (!merchants.length) return '#';
  const merchant = head(merchants);

  if (isNil(merchant)) return '#';

  const megaCategory = head(merchant.megaCategories);

  if (isNil(megaCategory)) return '#';

  const url = megaCategory.name
    .split(/\s+/)
    .join('-') // Make slug
    .toLowerCase();

  return `/${url}`;
};
